/**
 * Default top-bar titles by path prefix (most specific first).
 * Menu labels cover list sections; this map fills gaps and aliases.
 */
export const ROUTE_PAGE_TITLES = [
  { match: /^\/services\/packages\//, title: 'Service package' },
  { match: /^\/jobs\/[^/]+/, title: 'Job details' },
  { match: /^\/candidates\/[^/]+/, title: 'Candidate' },
  { match: /^\/resumes\/[^/]+\/studio/, title: 'Resume Builder' },
  { match: /^\/resumes/, title: 'My Resumes' },
  { match: /^\/linkedin-studio/, title: 'LinkedIn Studio' },
  { match: /^\/ai-studio/, title: 'AI Studio' },
  { match: /^\/erp\/selling/, title: 'Sales' },
  { match: /^\/erp$/, title: 'Finance overview' },
  { match: /^\/sales/, title: 'Sales' },
  { match: /^\/crm-pipeline/, title: 'Sales pipeline' },
  { match: /^\/crm$/, title: 'Interactions' },
  { match: /^\/finance\/payouts/, title: 'Consultant payouts' },
  { match: /^\/support\/new/, title: 'New ticket' },
  { match: /^\/support/, title: 'Support' },
  { match: /^\/settings/, title: 'Settings' },
  { match: /^\/users/, title: 'Users' },
  { match: /^\/$/, title: 'Dashboard' },
];

function menuPathMatchLength(path, item) {
  if (item.matchPaths?.length) {
    let best = 0;
    for (const p of item.matchPaths) {
      if (path === p || path.startsWith(`${p}/`)) {
        best = Math.max(best, p.length);
      }
    }
    return best;
  }
  if (item.path === '/') {
    return path === '/' ? 1 : 0;
  }
  if (path === item.path || path.startsWith(`${item.path}/`)) {
    return item.path.length;
  }
  return 0;
}

export function titleFromPath(pathname, menuItems = []) {
  const path = pathname || '/';

  let bestLabel = null;
  let bestLen = 0;
  for (const item of menuItems) {
    const len = menuPathMatchLength(path, item);
    if (len > bestLen) {
      bestLen = len;
      bestLabel = item.label;
    }
  }
  if (bestLabel) return bestLabel;

  for (const rule of ROUTE_PAGE_TITLES) {
    if (rule.match.test(path)) return rule.title;
  }

  return 'GoDash';
}
